import React from "react";
import {
  FaThumbtack,
  FaCalendarAlt,
} from "react-icons/fa";

export default function RightSidebar({
  posts = [],
  events = [],
}) {
  const pinnedPosts = posts.filter((p) => p.pinned);

  return (
    <aside className="space-y-6">

      {/* FÄSTA INLÄGG */}
      <div className="rounded-2xl border border-neutral-200 bg-white p-5">
        <div className="mb-4 flex items-center gap-2">
          <FaThumbtack className="text-[#3BAFA3]" />
          <h3 className="font-semibold text-neutral-900">
            Fästa inlägg
          </h3>
        </div>

        <div className="space-y-3">
          {pinnedPosts.length === 0 ? (
            <p className="text-sm text-neutral-500">
              Inga fästa inlägg.
            </p>
          ) : (
            pinnedPosts.map((post) => (
              <div
                key={post.id}
                className="
                  rounded-xl
                  bg-[#F8FAFA]
                  border
                  border-neutral-200
                  p-3
                "
              >
                <div className="font-medium text-neutral-900">
                  {post.title}
                </div>

                <p className="mt-1 line-clamp-2 text-sm text-neutral-600">
                  {post.text}
                </p>
              </div>
            ))
          )}
        </div>
      </div>

      {/* AKTIVITETER */}
      <div className="rounded-2xl border border-neutral-200 bg-white p-5">
        <div className="mb-4 flex items-center gap-2">
          <FaCalendarAlt className="text-[#3BAFA3]" />
          <h3 className="font-semibold text-neutral-900">
            Kommande aktiviteter
          </h3>
        </div>

        <div className="space-y-3">
          {events.length === 0 ? (
            <p className="text-sm text-neutral-500">
              Inga aktiviteter.
            </p>
          ) : (
            events.map((event) => (
              <div
                key={event.id}
                className="
                  rounded-xl
                  border
                  border-neutral-200
                  p-3
                "
              >
                <div className="font-medium text-neutral-900">
                  {event.title}
                </div>

                <div className="mt-1 text-sm text-neutral-500">
                  {event.date}
                </div>
              </div>
            ))
          )}
        </div>
      </div>

    </aside>
  );
}